import React from "react";
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Checkbox, Radio, CheckboxMainGroup, CheckboxMainGroupChildren } from './common'
import { withCookies } from 'react-cookie';
import queryString from 'query-string';

import {
    getFormInitialisationData,
    locationChanged,
    locationSet,
    cancerTypeChanged,
    searchEntityTypeChanged,
    doctorTypesChanged,
    doctorTypeGroupsChanged,
    treatmentTypesChanged,
    languageChanged,
    genderChanged,
    publicOnlyChanged,
    childrenAndYouthServicesChanged,
    childrenAndYouthTeamsChanged
  } from '../modules/advancedSearchFiltersReducer'
import {
    fetchResults
  } from '../modules/advancedSearchResultsReducer'

class AdvancedSearchFilters extends React.Component{
    componentDidMount(){
        this.firstLoadDone = false;
        const { getFormInitialisationData, cookies, cancerTypeChanged, 
            locationChanged, languageChanged, genderChanged, childrenAndYouthServicesChanged,
            childrenAndYouthTeamsChanged } = this.props;
        $('#childrenAndYouthServices').select2({
            allowClear: true,
            placeholder: 'Select children or youth services'
        });

        $('#childrenAndYouthTeams').select2({
            allowClear: true,
            placeholder: 'Select children or youth teams'
        });

        $('#location').on('select2:selecting', (e) => {locationChanged(e.params.args && e.params.args.data)});
        $('#location').on('select2:unselect', (e) => {locationChanged(e.params.args && e.params.args.data)});
        $('#cancertype').on('select2:selecting', (e) => {cancerTypeChanged(e.params.args && e.params.args.data)});
        $('#cancertype').on('select2:unselect', (e) => { cancerTypeChanged(e.params.args && e.params.args.data) });
        $('#language').on('select2:selecting', (e) => { languageChanged(e.params.args && e.params.args.data) });
        $('#language').on('select2:unselect', (e) => { languageChanged(e.params.args && e.params.args.data) });
        $('#gender').on('select2:selecting', (e) => { genderChanged(e.params.args && e.params.args.data) });
        $('#gender').on('select2:unselect', (e) => { genderChanged(e.params.args && e.params.args.data) });
        $('#childrenAndYouthServices').on('select2:selecting', (e) => { childrenAndYouthServicesChanged(e.params.args && e.params.args.data) });
        $('#childrenAndYouthServices').on('select2:unselect', (e) => { childrenAndYouthServicesChanged(e.params.args && e.params.args.data) });
        $('#childrenAndYouthTeams').on('select2:selecting', (e) => { childrenAndYouthTeamsChanged(e.params.args && e.params.args.data) });
        $('#childrenAndYouthTeams').on('select2:unselect', (e) => { childrenAndYouthTeamsChanged(e.params.args && e.params.args.data) });

        let params = queryString.parse(location.search);

        getFormInitialisationData(params);

        cancerTypeChanged({id : cookies.cookies['CURRENTCT'], text: cookies.cookies['CURRENTCTT']});
        locationChanged({id : cookies.cookies['CURRENTLOC'], text: cookies.cookies['CURRENTLOCT']});
    }
    componentDidUpdate(){

        if(!this.firstLoadDone){

            const { cancerType, location, searchEntityType, language, gender, fetchResults,
                asFormInitialisationData, publicOnly } = this.props;
            if (!asFormInitialisationData.TreatmentTypes) {
                return;
            }
            this.firstLoadDone = true;

            fetchResults({
                cancerType: cancerType,
                location: location,
                searchEntityType: searchEntityType,
                publicOnly: publicOnly,
                treatmentTypes: asFormInitialisationData.TreatmentTypes.filter(t => t.checked),
                doctorTypes: asFormInitialisationData.DoctorTypeGroups,
                language: language,
                gender: gender
            });
        }
    }
    render(){
        const { fetchResults, isFetchingResults, location, locationHasEror, cancerTypeHasError, language, 
            gender, searchEntityType, searchEntityTypeChanged, asFormInitialisationData, cancerType, 
            doctorTypesChanged, doctorTypeGroupsChanged, treatmentTypesChanged, publicOnlyChanged, 
            publicOnly, childrenAndYouthServices, childrenAndYouthTeams, locationSet } = this.props;

        const errorStyle = {
            display: 'block'
        };

        const doctorTypeGroupsOnChange = (e) => {
            doctorTypeGroupsChanged(e);
            this.forceUpdate();
        } 

        const doctorTypesOnChange = (e) => {
            doctorTypesChanged(e);
            this.forceUpdate();
        } 
        
        const handleSubmit = (e) => {
            e.preventDefault();
            if(locationHasEror || cancerTypeHasError){
                return;
            }

            if(!location.id && !location.text)
                locationSet(location);

            fetchResults({
                cancerType: cancerType,
                location: location,
                searchEntityType: searchEntityType,
                publicOnly : publicOnly,
                childrenAndYouthServices : childrenAndYouthServices,
                childrenAndYouthTeams : childrenAndYouthTeams,
                treatmentTypes: asFormInitialisationData.TreatmentTypes.filter(t => t.checked),
                doctorTypes: asFormInitialisationData.DoctorTypeGroups,
                language: language,
                gender: gender
            });
            $('html, body').animate({ scrollTop: $('#searchsection').offset().top + 20 })
        };

        const mainGroupCheckboxIndeterminate = (doctorTypes) => {
            if (doctorTypes && doctorTypes.length > 0) {
                let checkedDoctorTypesLength = doctorTypes.filter(t => t.checked).length;
                return checkedDoctorTypesLength != 0 && checkedDoctorTypesLength < doctorTypes.length;
            }
            return false; 
        };

        return (
            <div>
                <form id="advsearchForm">
                    <fieldset>
                        <legend>What are you searching for?</legend>
                        <div className="form-group">
                            <label>Find</label>
                            <Radio name="searchentitytype" id="customRadioSpecialist" value="specialists" checked={searchEntityType === 'specialists'} 
                                    onChange={searchEntityTypeChanged} collapseTarget="#specialistgroup">Cancer specialists</Radio>

                            <Radio name="searchentitytype" id="customRadioTeams" value="teams" checked={searchEntityType === 'teams'} 
                                    onChange={searchEntityTypeChanged} collapseTarget="#teamgroup">Multidisciplinary cancer care teams</Radio>

                            <Radio name="searchentitytype" id="customRadioServices" value="services" checked={searchEntityType === 'services'} 
                                    onChange={searchEntityTypeChanged} collapseTarget="#servicegroup">Cancer services</Radio>

                        </div>
                        <div className={`form-group ${cancerTypeHasError && 'is-invalid'}`}>
                            <label htmlFor="cancertype">Enter your cancer type</label>
                            <select className="form-control" id="cancertype"
                                    name="cancertype" data-placeholder="Enter a cancer type" required="">
                                <option></option>
                            </select>
                            { cancerTypeHasError && <span id="cancerType-error" className="is-invalid invalid-feedback" style={errorStyle}>This field is required.</span> }
                        </div>
                        <div className={`form-group ${locationHasEror && 'is-invalid'}`} >
                            <label htmlFor="location">Enter your location</label>
                            <select className="form-control" id="location" name="location" data-placeholder="Enter a suburb or postcode" required=""
                                value={location}>
                                <option></option>
                            </select>
                            { locationHasEror && <span id="location-error" className="is-invalid invalid-feedback" style={errorStyle}>This field is required.</span> }
                        </div>
                        <div id="specialistgroup" className={`collapse in ${searchEntityType === 'specialists' ? 'show' : ''}`}>
                            <div className="form-group">
                                <label htmlFor="">Type of cancer specialist</label>
                                
                                {
                                    asFormInitialisationData 
                                    && asFormInitialisationData.DoctorTypeGroups 
                                    && asFormInitialisationData.DoctorTypeGroups.map((c, i) => 
                                        <div>
                                            <CheckboxMainGroup name="cancerspecialist" id={c.Name} value={c.Text} children={c.DoctorTypes}
                                                indeterminate={mainGroupCheckboxIndeterminate(c.DoctorTypes)}
                                                checked={c.checked} onChange={doctorTypeGroupsOnChange}></CheckboxMainGroup>
                                            {
                                                c.DoctorTypes 
                                                && c.DoctorTypes.length > 0
                                                && <CheckboxMainGroupChildren id={c.Name} name="cancerspecialist" children={c.DoctorTypes} onChange={doctorTypesOnChange}></CheckboxMainGroupChildren>
                                            }
                                        </div>
                                    )
                                }
                            </div>
                            <div className="form-group">
                                <label htmlFor="language">Language</label>
                                <select className="form-control select" id="language" name="language" value={language}>
                                    <option></option>
                                    {
                                        asFormInitialisationData 
                                        && asFormInitialisationData.Languages 
                                        && asFormInitialisationData.Languages.map((c, i) => <option id={c.Name} value={c.Name}>{c.Text}</option>)
                                    }
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="gender">Gender</label>
                                <select className="form-control select" id="gender" name="gender" value={gender}>
                                    <option></option>
                                    <option id="male" value='0'>Male</option>
                                    <option id="female" value='1'>Female</option>
                                </select>
                            </div>
                        </div>
                        <div id="servicegroup" className={`collapse ${searchEntityType === 'services' ? 'show' : ''}`}>
                            <div className="form-group">
                                <label htmlFor="">Type of treatment or service</label>

                                {
                                    asFormInitialisationData 
                                    && asFormInitialisationData.TreatmentTypes 
                                    && asFormInitialisationData.TreatmentTypes.map((c, i) => <Checkbox name="servicetype" id={c.Name} value={c.Name} checked={c.checked} 
                                    onChange={treatmentTypesChanged} key={i}>{c.Text}</Checkbox>)
                                }
                                
                            </div>
                            <div className="form-group">
                                <label htmlFor="">Public/Private</label>
                                <div className="custom-control custom-checkbox">
                                    <input type="checkbox" className="custom-control-input" name="publicprivate" id="public"
                                        value="public" checked={publicOnly} onChange={publicOnlyChanged}></input>
                                    <label className="custom-control-label" htmlFor="public">Show public services only</label>
                                </div>
                            </div>
                        </div>
                        <div id="childrenAndYouthServicesGroup" className={`collapse ${searchEntityType === 'teams' || searchEntityType === 'services' ? 'show' : ''}`}>
                            <div className="form-group">
                                <label htmlFor="">Children and youth services</label>
                                <div className={`${searchEntityType === 'services' ? 'show' : 'd-none'}`}>
                                    <select className="form-control select" id="childrenAndYouthServices">
                                        <option></option>
                                        <option value="children">Show children's services only</option>
                                        <option value="youth">Show youth services only</option>
                                    </select>
                                </div>
                                <div className={`${searchEntityType === 'teams' ? 'show' : 'd-none'}`}>
                                    <select className="form-control select" id="childrenAndYouthTeams">
                                        <option></option>
                                        <option value="children">Show children's teams only</option>
                                        <option value="youth">Show youth teams only</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset>
                        <legend>Search by doctor or hospital name</legend>
                        <div className="form-group">
                            <label htmlFor="cancertype" class="sr-only">Search for</label>
                            <select className="form-control select" id="searchbyname" data-placeholder="Enter a doctor, team or hospital name">
                                <option></option>
                            </select>
                        </div>
                    </fieldset>
                    <button id="submit" 
                        type="submit" 
                        className="mt-3 btn btn-primary btn-block btn-submit" onClick={handleSubmit} aria-controls="advancedSearchResults">Search</button>
                </form>
            </div>
      );
    }
}
const mapStateToProps = ({ advancedSearchFiltersData }) => {
        return ({
            isFetchingResults: advancedSearchFiltersData.isFetchingResults,
            location: advancedSearchFiltersData.location,
            locationHasEror: advancedSearchFiltersData.locationHasEror,
            cancerTypeHasError: advancedSearchFiltersData.cancerTypeHasError,
            searchEntityType: advancedSearchFiltersData.searchEntityType,
            cancerType: advancedSearchFiltersData.cancerType,
            asFormInitialisationData: advancedSearchFiltersData.asFormInitialisationData,
            doctorTypeGroups: advancedSearchFiltersData.doctorTypeGroups,
            treatmentTypes: advancedSearchFiltersData.treatmentTypes,
            language: advancedSearchFiltersData.language,
            gender: advancedSearchFiltersData.gender,
            publicOnly: advancedSearchFiltersData.publicOnly,
            childrenAndYouthServices: advancedSearchFiltersData.childrenAndYouthServices,
            childrenAndYouthTeams: advancedSearchFiltersData.childrenAndYouthTeams
        });
    }
  
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchResults,
            locationChanged,
            locationSet,
            cancerTypeChanged,
            doctorTypesChanged,
            doctorTypeGroupsChanged,
            treatmentTypesChanged,
            searchEntityTypeChanged,
            languageChanged,
            genderChanged,
            getFormInitialisationData,
            publicOnlyChanged,
            childrenAndYouthServicesChanged,
            childrenAndYouthTeamsChanged
        },
        dispatch
    )


export default withCookies(connect(
    mapStateToProps,
    mapDispatchToProps
  )(AdvancedSearchFilters))